import React from "react";

function PaymentCount({ count }: any) {
  return (
    <div className="cards">
      <div
        className="card"
        style={{ backgroundColor: "rgb(251 208 66 / 30%)" }}
      >
        <h1>{count?.totalSum ?? 0}</h1>
        <span>Total</span>
      </div>
      <div
        className="card"
        style={{ backgroundColor: "rgb(250 173 20 / 30%)" }}
      >
        <h1>{count?.discountSum ?? 0}</h1>
        <span>discount</span>
      </div>
      <div
        className="card"
        style={{ backgroundColor: "rgb(173 216 230 / 30%)" }}
      >
        <h1>
          {(count?.bankTransferSum ?? 0) +
            (count?.cashSum ?? 0) +
            (count?.cardSum ?? 0)}
        </h1>
        <span>paid</span>
      </div>
      <div className="card">
        <h1>{count?.cardSum ?? 0}</h1>
        <span>card</span>
      </div>
      <div className="card" style={{ backgroundColor: "rgb(82 196 26 / 30%)" }}>
        <h1>{count?.bankTransferSum ?? 0}</h1>
        <span>transfer</span>
      </div>
      <div className="card" style={{ backgroundColor: "rgb(247 49 49 / 30%)" }}>
        <h1>{count?.cashSum ?? 0}</h1>
        <span>cash</span>
      </div>
    </div>
  );
}

export default PaymentCount;
